import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { DELETE_TENANT_MUTATION } from "../../../graphql/mutations";

const DeleteTenantModal = ({ show, tenant, handleClose, env, handleEnvChange }) => {
  const navigate = useNavigate();
  const [deleteTenant, { loading: mutationLoading }] = useMutation(DELETE_TENANT_MUTATION);

  const handleDelete = async () => {
    try {
      const { data } = await deleteTenant({
        variables: {
          tenantId: tenant.id
        }
      });
      if (data?.deleteTenantById) {
        setTimeout(() => {
          toast.success(`Database tenant with ID: ${tenant.id} deleted successfully`);
          navigate("/tenants");
          handleEnvChange(env);
        }, 200);
      } else {
        toast.error("Failed to edit tenant.");
      }
    } catch (err) {
      setTimeout(() => {
        toast.error("Failed to delete tenant.");
      }, 200);
    } finally {
      handleClose();
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Tenant</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to delete tenant <strong>{tenant.name}</strong>?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          No
        </Button>
        <Button variant="danger" onClick={handleDelete}>
          {mutationLoading ? "Deleting tenant..." : "Yes"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export { DeleteTenantModal };
